// SDKError class that extends Error interface implements the IErrorContract interface
export class SDKError extends Error {
    constructor(message) {
        super(message); // Call the parent class (Error) constructor with the message
        Object.defineProperty(this, "source", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'SDK'
        }); // The source of the error, fixed as 'SDK'
        Object.defineProperty(this, "message", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.message = message;
    }
}
//# sourceMappingURL=SDKError.js.map